import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { DocsTab } from '../../Docs/DocsTab';
import { ReextractPanel } from './ReextractPanel';
export function DocsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsxs(PageBody, {
        children: [
            /*#__PURE__*/ _jsx(ReextractPanel, {}),
            /*#__PURE__*/ _jsx(DocsTab, {
                programId: programId
            })
        ]
    });
}
